export default {"src":"/_next/static/media/starfruit.8bca4d89.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};